function disableTracking(scope) {
    // console.log("GA Disabled.");
    scope.$ga.disable();
}
function enableTracking(scope) {
    // console.log("GA Enabled.");
    scope.$ga.enable();
    // Missing actions for GA cookie setting, not sure they are needed.
    // scope.$ga.page(scope.$route.path);
}

export default {
    setListeners: scope => {
        document.addEventListener("click", (e) => {
            const acceptIds = ["onetrust-accept-btn-handler", "accept-recommended-btn-handler"];
            const savePrefClass = "save-preference-btn-handler";
            if (acceptIds.includes(e.target.id)) { enableTracking(scope); }
            // if class and checkbox active -> enable, else -> disable.
            if (e.target.className.includes(savePrefClass)) {
                // Checkbox active
                if (document.getElementById("ot-group-id-C0002").checked) { enableTracking(scope); }
                else {
                    // Checkbox inactive
                    disableTracking(scope);
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/services/OneTrustService.js